import { Component, OnInit, Input } from '@angular/core';

import { ContextMain } from '../_models/common/context.main';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  @Input() ctx: ContextMain;

  constructor() { }

  ngOnInit() {
  }

}
